import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import {Table, Row, Col, Button} from 'reactstrap';
import ProblemListBreadcrumbs from '../breadcrumbs/ProblemListBreadcrumbs'

//Data
import {serverPath} from '../common';

// Route: /p/course/:courseId/topic/:topicId
class PCourseProblemList extends Component
{

	constructor(props)
	{
        super(props);

        this.state = {
            problemList: [],
            topicName: "",
            topicDescription: "",
			breadCrumbsData: 
			{
				userPrefix: 'p',
				courseId: 0,
				courseName: '',
				topicName: ''
			}
        };
    }

	/**
	 * @description Use this function to fetch data from server
	 **/
	getData()
	{

		axios.get(serverPath + 'professorService.php',
			{
				params:
				{
					action:'getTopicData',
					topicId:this.props.match.params.topicId
				}
			})
			.then((response)=>
				{
					var data  = response.data;


					this.setState(
						{
							topicName:data.topicInfo.name,
                            topicDescription: data.topicInfo.description,
							problemList:data.problems,
							breadCrumbsData:
							{
								userPrefix: 'p',
								courseId: this.props.match.params.courseId,
								courseName: data.topicInfo.courseName,
								topicName: data.topicInfo.name
							}
						});
				});
    }


	/**
	 * @description Use this function to auth user
	 **/
	componentDidMount()
	{
		this.getData();
	}

	/**
	 * @description Use this function to fetch data if props have changed
	 **/
	componentDidUpdate(prevProps)
	{
		if(prevProps.match.params.topicId !== this.props.match.params.topicId)
		{
			this.getData();
		}
	}


	render() 
	{

		const body = this.state.problemList.map((el)=>
			{
				const link = this.props.match.url +
					((this.props.match.url.endsWith('/')) ? '' : '/') +
					'problem/';
				return (
					<tr key = {el.id}>
						<th scope='row' style={{textAlign:'center'}}>{el.index}</th>
						<td align='center'>
							<Link to = {link + el.id} className="default-link" >
								{el.name}
							</Link>
						</td>
						<td align = 'center'>{el.timesSolved}</td>
					</tr>
				);
			});

        return (
			<Col>
				<Row>
					<Col>
						<ProblemListBreadcrumbs data={this.state.breadCrumbsData}/>
					</Col>
				</Row>
				<Row className='justify-content-end'>
					<Col xs='auto'>
						<Link to={`${this.props.match.url}/edit`}>
							<Button color='primary'>
								Izmeni ovu temu
							</Button>
						</Link>
					</Col>
				</Row>
				<Row className='mt-2'>
					<Col className='card'>
						<Row className='mt-2'>
							<Col>
								<h3 style={{textAlign:'center'}}>{this.state.topicName}</h3>
							</Col>
						</Row>
						<Row>
							<Col xs='8' className='offset-2'> {this.state.topicDescription}</Col>
						</Row>
						<Row>
							<Col xs='8' className='offset-2'>
								<Table bordered striped>
									<thead>
										<tr>
											<th style={{textAlign:'center'}}>#</th>
											<th style={{textAlign:'center'}}>Problem</th>
											<th style={{textAlign:'center'}}>Resilo studenata</th>
										</tr>
									</thead>
									<tbody>
										{body}
									</tbody>
								</Table>
                                <Link to={`${this.props.match.url}/problem/new`}>
									<Button color="primary"> Dodaj novi zadatak </Button>
								</Link>
							</Col>
						</Row>
					</Col>
				</Row>
			</Col>
         );
    }
}

export default PCourseProblemList;
